module.exports = __webpack_public_path__ + "static/media/linkedinDark.4ff2dcfa.svg";